module.exports = __webpack_public_path__ + "static/media/MonoTAKD_cover.54486c24.jpg";